export enum UserAuthState {
  Unknown,
  NonAuthenticated,
  Authenticated,
}
